import { Directive, HostListener, Input } from "@angular/core";

@Directive({
    selector: '[app-allow-pattern]'
})
export class AllowPatternDirective {
    @Input() allowPattern: string;

    constructor() {}

    @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
        if(!event.key.match(new RegExp(this.allowPattern, "i"))){
            return false;
        }
    }

}

